<template>
  <section :class="classes" class="w-full">
    <slot></slot>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
export interface Props {
  background: 'white' | 'blue' | 'blue-light' | 'blue-dark' | 'black'
  space?: 'with-space' | 'without-space'
}
const props = withDefaults(defineProps<Props>(), {
  background: 'white',
  space: 'with-space',
})

// Set section background color
/* const background = computed(() =>
  props.background === 'blue-light' || props.background === 'blue'
    ? 'bg-blue-lighter group is-blue'
    : 'bg-white group is-white',
) */

const background = computed(() => {
  switch (props.background) {
    case 'white':
      return 'bg-white group is-white'
    case 'blue':
      return 'bg-blue-lighter text-white group is-blue'
    case 'blue-light':
      return 'bg-blue-lighter text-black group is-blue'
    case 'blue-dark':
      return 'bg-blue-darkest group is-blue-dark'
    case 'black':
      return 'bg-black-dark group is-black'
    default:
      return 'bg-white group is-white'
  }
})

// Set section vertical space
const classes = computed(() => {
  return props.space === 'without-space'
    ? background.value
    : background.value + ' space-y-12 py-12 lg:space-y-24 lg:py-24'
})
</script>
